module.exports = __webpack_public_path__ + "img/p13.4409873f.png";